module.exports = __webpack_public_path__ + "img/6.c30c0d74.jpg";